import * as Yup from 'yup';

const CreateSignupSchema = Yup.object().shape({
  phone: Yup.string()
    .matches(/^\d+$/, 'يسمح بإدخال الأرقام فقط')
    .required('مطلوب'),
});

export default CreateSignupSchema;
